import 'rc-pagination/assets/index.css';
import { lazy } from 'react';
const Pagination = lazy(() => import('rc-pagination'));
//import Pagination from "rc-pagination";
import styled from 'styled-components';
import { useScreenDetector } from '@/utils/useScreenDetector';

const CustomPagination = ({ pageSize, onChange, current, total, page }) => {
  const { isMobile } = useScreenDetector();

  return (
    <PaginationWrapper>
      <Pagination
        simple={isMobile}
        pageSize={pageSize}
        onChange={onChange}
        current={current}
        total={total}
        defaultCurrent={page}
      />
    </PaginationWrapper>
  );
};
export default CustomPagination;

const PaginationWrapper = styled.div.attrs({
  className: 'PaginationWrapper',
})`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  grid-column: 1/-1;
  .rc-pagination {
    display: inline-flex;
    @media only screen and (min-width: 992px) {
      justify-content: center;
      align-items: center;
      width: 100%;
      flex-wrap: wrap;
    }
  }
  @media only screen and (min-width: 992px) {
    .rc-pagination-prev,
    .rc-pagination-item,
    .rc-pagination-next,
    .rc-pagination-jump-next,
    .rc-pagination-jump-prev {
      width: 4em !important;
      height: 4em !important;
      display: table-cell;
      line-height: 1.5em !important;
    }
    .rc-pagination-item,
    .rc-pagination-jump-next,
    .rc-pagination-jump-prev {
      padding-top: 1.2em !important;
    }
    .rc-pagination-prev button:after,
    .rc-pagination-next button:after {
      font-size: 1.8rem !important;
    }
  }
  @media only screen and (max-width: 992px) {
    .rc-pagination-prev,
    .rc-pagination-item,
    .rc-pagination-next,
    .rc-pagination-jump-next,
    .rc-pagination-jump-prev {
      width: 2.8em !important;
      height: 2.8em !important;
      display: table-cell;
    }
    .rc-pagination-item,
    .rc-pagination-jump-next,
    .rc-pagination-jump-prev {
      padding-top: 0.34em !important;
    }
  }

  .rc-pagination-item-active {
    border-color: ${(props) => props.theme.colors.blue};
    background-color: ${(props) => props.theme.colors.blue};
    a {
      color: white !important;
    }
  }
  .rc-pagination-item a {
    color: ${(props) => props.theme.colors.blue};
  }
`;
